import React, { useEffect } from 'react';
import QuizReview from '../../components/assessment/review';
import { useParams } from 'react-router-dom';
import ErrorMessage from '../../components/errormessage';
import { observer } from 'mobx-react';
import MetaTags from 'react-meta-tags';
import { useStores } from '../../hooks/use-stores';

function AssessmentResults({ parentMatch }) {
    const { variant, shareKey } = useParams();
    const { assessmentStore } = useStores();
    const { error, loadingAssessmentResults, assessment, results } =
        assessmentStore;

    useEffect(() => {
        if (shareKey) assessmentStore.loadSharedResults(shareKey, variant);
    }, [shareKey]);

    return (
        <>
            <ErrorMessage error={error} />
            {loadingAssessmentResults ||
            !assessmentStore.assessment ||
            !results ? (
                <> loading</>
            ) : (
                <>
                    <MetaTags>
                        <title>My cyber security score</title>
                        <meta property="og:type" content="article" />
                        <meta
                            property="og:title"
                            content="My cyber security score"
                        />
                        <meta
                            property="og:description"
                            content="See how well you do on our cyber security quiz"
                        />
                        <meta
                            id="og-image"
                            property="og:image"
                            content={
                                window.location.origin +
                                `/scores/` +
                                assessment.score +
                                '.png'
                            }
                        />
                    </MetaTags>
                    <QuizReview
                        parentUrl={parentMatch && parentMatch.url}
                        assessmentStore={assessmentStore}
                        assessment={assessment}
                        assessmentId={variant}
                        preloadedResults={results}
                        shareResults={true}
                        companyId={variant}
                    />
                </>
            )}
        </>
    );
}

export default observer(AssessmentResults);
